import { observable } from "micro-observables";
import { toast } from "react-toastify";

import { DEFAULT_BLOCK_SELECTOR, NORMALIZERS } from "../../../constants";
import { editConfigRequest, getNormalizerUrlsByCode } from "../../../api";
import { getErrorMessage } from "../../../../../utils/sagasErrorHandler";
import { sharedHistory } from "../../../../../routes/sharedHistory";
import { ROUTES_MAP } from "../../../../../routes/constants";
import { CONFIG_MANAGER_LIGHT_STEPS } from "../../../index";

export const isLoadingUrls = observable(false);
export const tabIndex = observable(0);
export const currentBlockSelector = observable(DEFAULT_BLOCK_SELECTOR);
export const blockSelectors = observable([]);

export const activeDataSelector = observable(null);
export const newDataSelector = observable(null);

export const iframeList = observable([]);
export const currentIframe = observable(null);
export const currentIframeWrapper = observable(null);
export const selectedElement = observable(null);

export const urlList = observable([]);

export const setIframeList = (list) => {
    iframeList.set(list);
};

export const setTabIndex = (index) => {
    tabIndex.set(index);
};

export const setCurrentBlockSelector = (selector) => {
    currentBlockSelector.set(selector);
};

export const setBlockSelectors = (selectors) => {
    blockSelectors.set(selectors);
};

export const setIsLoadingUrls = (state) => {
    isLoadingUrls.set(state);
};

export const setSelectedElement = (element) => {
    selectedElement.set(element);
};

export const setActiveDataSelector = (selector) => {
    activeDataSelector.set(selector);
};

export const setNewDataSelector = (selector) => {
    newDataSelector.set(selector);
};

export const setCurrentIframe = (iframe) => {
    currentIframe.set(iframe);
};

export const setCurrentIframeWrapper = (iframe) => {
    currentIframeWrapper.set(iframe);
};

export const setUrlList = (list) => {
    urlList.set(list);
};

const getNormalizedUrls = async (normalizers, normalizersDataObject, index = 1) => {
    const params = {};
    if(normalizers[index - 1].options) {
        params.normalizer_options = normalizers[index - 1].options;
    }

    const { normalized_data } = await getNormalizerUrlsByCode(normalizers[index - 1].code, normalizersDataObject, params);

    const newNormalizersDataObject = { ...normalizersDataObject };
    newNormalizersDataObject.data = normalized_data;

    if(index === normalizers.length) {
        return normalized_data;
    }

    return getNormalizedUrls(normalizers, newNormalizersDataObject, index+1);
};

export const requestNormalizersByUrls = async ({ hrefs, isMultiple, scrapeTaskUrl, normalizers }) => {
    try {
        setIsLoadingUrls(true);
        setUrlList([]);
        let normalizedData;

        let normalizersDataObject = {
            data: hrefs,
            scrapeTaskUrl
        };

        if (!normalizers || normalizers.length === 0) {
            const { normalized_data } = await getNormalizerUrlsByCode(NORMALIZERS[0].code, normalizersDataObject);

            normalizedData = normalized_data;
            normalizersDataObject.data = normalized_data;

            if(isMultiple) {
                const { normalized_data } = await getNormalizerUrlsByCode(NORMALIZERS[1].code, normalizersDataObject);
                normalizedData = normalized_data;
            }
        } else {
            normalizedData = await getNormalizedUrls(normalizers, normalizersDataObject);
        }


        setUrlList(normalizedData);
    } catch (error) {
        getErrorMessage(error);
    } finally {
        setIsLoadingUrls(false);
    }
};

export const updateConfigDataRequest = async (payload) => {
    try {
        await editConfigRequest(payload);

        toast.success("The Config has been successfully updated");

        const { search } = window.location;

        sharedHistory.push(`${ROUTES_MAP.configManagerLite.path}/${CONFIG_MANAGER_LIGHT_STEPS.four}${search}`);
    } catch (error) {
        getErrorMessage(error);
    }
};

export const clearStepThreeData = () => {
    setTabIndex(0);
    setIsLoadingUrls(false);

    setSelectedElement(null);

    setUrlList([]);
    setBlockSelectors([]);
    setIframeList([]);

    setActiveDataSelector(null);

    setCurrentIframe(null);
    setCurrentIframeWrapper(null);
};
